<template>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col p-col-12 p-md-12 p-lg-12" style="font-size: 13px">
      <Panel header="Tra cứu thông tin CLS của bệnh nhân">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-4 p-lg-3">
            <label style="font-size: 13px">Mã y tế</label>
            <InputGroup>
              <InputText type="text" :useGrouping="false"  id="name" placeholder="Nhập mã bệnh nhân..." v-model="maYTe" style="text-align: center;font-size: 13px"  v-on:keyup.enter="loadListCls()" />
              <!--              <Button label="Xóa" icon="pi pi-pi-trash" iconPos="left" severity="danger" />-->
              <Button label="Xóa" icon="pi pi-delete-left" severity="danger" iconPos="left" @click="deleteData()" style="font-size: 13px"/>
            </InputGroup>
          </div>
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12" v-if="openCamera" >
              <div class="stream">
                <StreamBarcodeReader
                    :zoom="2"
                    :autofocus="true"
                    @decode="onDecode"
                    @loaded="onLoaded"
                />
                <!--<qrcode-stream
                :constraints="selectedConstraints"
                :track="trackFunctionSelected"
                :formats="selectedBarcodeFormats"
                @detect="onDetect"
              />-->
              <barcode-scanner
      :paused="false"
      @decode="onDecodeLog"
      @error="onErrorLog"
    />
              </div>
          </div>
          <div class="p-field p-col p-col-6 p-md-3 p-lg-3">
            <label style="font-size: 13px">Tra cứu</label>
            <Button label="Tìm" icon="pi pi-search" iconPos="left" @click="loadListCls()" style="font-size: 13px"/>
          </div>
          <div class="p-field p-col p-col-6 p-md-3 p-lg-3">
            <label style="font-size: 13px">Quét mã bệnh nhân</label>
            <Button label="Quét mã" icon="pi pi-barcode" severity="warning" iconPos="left" @click="scanBarcode()" style="font-size: 13px"/>
          </div>
        </div>
      </Panel>
    </div>
      <div class="p-field p-col p-col-12 p-md-12 p-lg-12" style="font-size: 13px">
      <Panel header="Thông tin bệnh nhân" v-if="listCLS.length > 0">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 13px">Mã y tế</label>
            <InputText id="maYTe" type="text" v-model="listCLS[0].mayte" style="text-align: center;font-size: 13px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 13px">Họ và tên</label>
            <InputText id="hoVaTen" type="text" v-model="listCLS[0].tenbenhnhan" style="text-align: center;font-size: 13px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
            <label style="font-size: 13px">Ngày sinh</label>
            <InputText id="ngaySinh" v-model="ngaySinh" type="text" style="text-align: center;font-size: 13px" disabled>
            </InputText>
          </div>
          <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <label style="font-size: 13px">Địa chỉ thường trú</label>
            <InputText id="diaChi" type="text" v-model="listCLS[0].diachithuongtru" style="text-align: center;font-size: 13px" disabled/>
          </div>
          <div class="p-field p-col p-col-12 p-md-12 p-lg-6">
            <label style="font-size: 13px">Chẩn đoán</label>
            <InputText id="chanDoan" type="text" v-model="listCLS[0].chandoan" style="text-align: center;font-size: 13px" disabled/>
          </div>
        </div>
      </Panel>
        </div>
    <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
      <Panel header="Danh sách dịch vụ CLS chưa thực hiện">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
            <DataTable
                :loading="isLoading"
                :value="listCLSChuaThucHien" :paginator="true" stripedRows :rows="30"
                :rowsPerPageOptions="[30,50,100]" :rowHover="true"
                v-model:filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :globalFilterFields="['tendichvu']"
                currentPageReportTemplate="Có tổng số {totalRecords} dịch vụ CLS" columnResizeMode="fit | expand">
              <template #header>
                <div class="p-d-flex p-jc-between p-ai-center">
                  <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 10em"/>
                  <span class="p-input-icon-left" style="width: 18em">
<!--                    <i class="pi pi-search" />-->
                    <InputText v-model="filters['global'].value" placeholder="Tìm theo dịch vụ" />
                  </span>
                </div>
              </template>
              <Column field="tendichvu" header="Tên dịch vụ" sortable></Column>
              <Column field="ngaygioyeucau" header="Thời gian yêu cầu" sortable>
                <template #body="slotProps">
                  {{formatDateTime(slotProps.data.ngaygioyeucau)}}
                </template>
              </Column>
              <Column field="sophieuyeucau" header="Số phiếu" sortable></Column>
              <Column field="tenphongban" header="Nơi chỉ định" sortable></Column>
              <Column field="hientrang"  header="Tình trạng" sortable>
                <template #body="slotProps">
                  <Button severity="danger"  type="button" :label="slotProps.data.hientrang" />
<!--                  <Button v-else severity="success"  type="button" label="ĐÃ THỰC HIỆN"></Button>-->
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </Panel>
    </div>
    <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
      <Panel header="Danh sách dịch vụ CLS Đã thực hiện" style="color: #2196f3">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
            <DataTable
                :loading="isLoading"
                :value="listCLSDaThucHien" :paginator="true" stripedRows :rows="30"
                :rowsPerPageOptions="[30,50,100]" :rowHover="true"
                v-model:filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :globalFilterFields="['tendichvu']"
                currentPageReportTemplate="Có tổng số {totalRecords} dịch vụ CLS" columnResizeMode="fit | expand">
              <template #header>
                <div class="p-d-flex p-jc-between p-ai-center">
                  <Button type="button" icon="pi pi-filter-slash" label="Xoá" class="p-button-outlined" @click="clearFilter()" style="width: 10em"/>
                  <span class="p-input-icon-left" style="width: 18em">
<!--                    <i class="pi pi-search" />-->
                    <InputText v-model="filters['global'].value" placeholder="Tìm theo dịch vụ" />
                  </span>
                </div>
              </template>
              <Column field="tendichvu" header="Tên dịch vụ" sortable></Column>
              <Column field="ngaygioyeucau" header="Thời gian yêu cầu" sortable>
                <template #body="slotProps">
                  {{formatDateTime(slotProps.data.ngaygioyeucau)}}
                </template>
              </Column>
              <Column field="sophieuyeucau" header="Số phiếu" sortable></Column>
              <Column field="tenphongban" header="Nơi chỉ định" sortable></Column>
              <Column field="hientrang"  header="Tình trạng" sortable>
                <template #body="slotProps">
                  <Button v-if="slotProps.data.trangthai == 'HOANTAT'"  severity="info" :label="slotProps.data.hientrang"  type="button">
<!--                    <label>{{contentTrangThai(slotProps.option.dvyeucaU_ID)}}</label>-->
                  </Button>
                  <Button v-else severity="warning" :label="slotProps.data.hientrang"  type="button">
<!--                    <label> {{contentTrangThai(slotProps.option.dvyeucaU_ID)}}</label>-->
                  </Button>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </Panel>
    </div>
    <div class="p-field p-col p-col-12 p-md-12 p-lg-12">
      <Dialog header="Đang tải dữ liệu" v-model:visible="loadingBar" >
        <div id="loading">
          <label>Đang tra cứu thông tin ...</label>
          <ProgressBar mode="indeterminate" style="height: .3em" />
        </div>
      </Dialog>
      <ConfirmDialog></ConfirmDialog>
    </div>
  </div>
</template>

<script lang="ts">

import moment from 'moment';
import { computed, ref } from 'vue'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {useStore} from "vuex";
import zaloRepository from "@/services/ZaloRepository";
import {FilterMatchMode} from "primevue/api";
import {Ds_Cls} from "@/models/ds_Cls";
import {FileDetail} from "@/models/fileDetail.models";
import axios from "axios";
import {Cls} from "@/models/cls";
import { StreamBarcodeReader } from '@teckel/vue-barcode-reader'
import { BarcodeScanner } from 'vue-barcode-reader'



// import { StreamBarcodeReader } from "vue-barcode-reader";



export default {
  components: { StreamBarcodeReader },
  methods: {
    onDetect(detectedCodes) {
      console.log("#####$$$$$$$$$$ onDetect: " );
      console.log(detectedCodes)
  //result.value = JSON.stringify(detectedCodes.map((code) => code.rawValue))
},
//     onResult(result: Result | undefined) {
//       console.log("#####$$$$$$$$$$ onDetect: " );
// }
  },
  setup(){
    const router = useRouter();
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const maYTe = ref("");
    const listCLS = ref([] as Ds_Cls[]);
    const listCLSChuaThucHien = ref([] as Ds_Cls[]);
    const listCLSDaThucHien = ref([] as Ds_Cls[]);
    const listFileCls = ref([] as Cls[]);
    const ngaySinh = ref("")
    const permissionCLS = ref(false);

    if((store.state.permission == 'cls')){
      permissionCLS.value = true;
    }

    const contentTrangThai = (id) =>{

      const st = ref('');
      console.log('########################$$$$$$ contentTrangThai id: ' + id);
      listCLS.value.forEach(x => {
        //11,18,13,10
        // CHUAKETQUA
        // DANGTHUCHIEN
        // HOANTAT
        // DALAYMAU
        if(x.dvyeucaU_ID == id) {
          console.log('########################$$$$$$ contentTrangThai x: ' + JSON.stringify(x));
          if ((x.nhomdichvU_ID == 11) || (x.nhomdichvU_ID == 18) || (x.nhomdichvU_ID == 13) || (x.nhomdichvU_ID == 10)
              || (x.nhomdichvU_ID == 1) || (x.nhomdichvU_ID == 9)) {
            if (x.trangthai == 'CHUAKETQUA') st.value = 'CHƯA LẤY MẪU';
            else if (x.trangthai == 'DALAYMAU') st.value = 'ĐÃ LẤY MẪU';
            else if (x.trangthai == 'HOANTAT') st.value = 'ĐÃ CÓ KẾT QUẢ';
            else st.value = '';
          } else {
            if (x.trangthai == 'CHUAKETQUA' ) {
              if(x.pacS_REPORT != '1')
              st.value = 'CHƯA THỰC HIỆN';
              else
              st.value = 'ĐÃ THỰC HIỆN';
            }
            else if ((x.trangthai == 'DACHUP') || (x.trangthai == 'CHOXACNHAN')) st.value = 'ĐÃ THỰC HIỆN';
            else if (x.trangthai == 'HOANTAT') st.value = 'ĐÃ CÓ KẾT QUẢ';
            else st.value = '';
          }
        }
      })

      return st.value;
    }

    const loadListCls = () => {
      loadingBar.value = true;
      console.log("#####$$$$$$$$$$ loadListCls: " );
      zaloRepository.getDanhSachCls(maYTe.value)
          .then((response) => {
            loadingBar.value = false;
            console.log("#####$$$$$$$$$$ loadListCls 0000000: " );
            listCLS.value = response.data;
            maYTe.value='';
            listCLS.value.forEach(x => {
              x.hientrang = contentTrangThai(x.dvyeucaU_ID);
              console.log('########################$$$$$$ contentTrangThai x.hientrang: ' + x.hientrang);
            })
            listCLSChuaThucHien.value = listCLS.value.filter(x => (x.trangthai == 'CHUAKETQUA')&&(x.pacS_REPORT != '1'));
            listCLSDaThucHien.value = listCLS.value.filter(x => (x.trangthai != 'CHUAKETQUA')||((x.trangthai == 'CHUAKETQUA')&&(x.pacS_REPORT == '1')));

            console.log("#####$$$$$$$$$$ loadListCls listCLS: " + JSON.stringify(listCLS.value));
            console.log("#####$$$$$$$$$$ loadListCls listCLSChuaThucHien: " + JSON.stringify(listCLSChuaThucHien.value));
            console.log("#####$$$$$$$$$$ loadListCls listCLSDaThucHien: " + JSON.stringify(listCLSDaThucHien.value));
            console.log("#####$$$$$$$$$$ loadListCls listCLS.value.length: " + listCLS.value.length);
            console.log("#####$$$$$$$$$$ loadListCls listCLSChuaThucHien.value.length: " + listCLSChuaThucHien.value.length);

            if(listCLS.value.length < 1){
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:'Bệnh nhân không có chỉ định cận lâm sàn',
                life: 2000
              });
            }

            if(listCLSChuaThucHien.value.length > 0)
            {
              console.log("#####$$$$$$$$$$ loadListCls 1111111: ");
              toast.add({
                  severity: 'warn',
                  summary: 'Chỉ định cận lâm sàn',
                  detail:'Bệnh nhân còn ' + listCLSChuaThucHien.value.length + ' chỉ định CLS chưa thực hiện',
                  life: 4000
                });
            }
            else if(listCLS.value.length > 0)
            {
              console.log("#####$$$$$$$$$$ loadListCls 222222: ");
              toast.add({
                severity: 'info',
                summary: 'Chỉ định cận lâm sàn',
                detail:'Bệnh nhân hoàn thành tất cả chỉ định CLS.',
                life: 4000
              });
            }

            if(listCLS.value[0].ngaysinh != null)
            {
              ngaySinh.value = formatDate(listCLS.value[0].ngaysinh);
            }
            console.log("#####$$$$$$$$$$ listCLS.value.length aaaa: ");

          })
          .catch(err => {
            loadingBar.value = false;
            console.log("#####$$$$$$$$$$ loadListCls 1111111: " );
            console.log("#####$$$$$$$$$$ loadListCls 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ loadListCls 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    const formatDateTime = (date) => {
      // console.log("@@@@@@@@@################ formatDateTime date: " + JSON.stringify(date));
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('HH:mm:ss DD/MM/YYYY');
    };

    const formatDate = (date) => {
      console.log("@@@@@@@@@################ formatDateTime date: " + JSON.stringify(date.value));
      if((date == null)||(date == ''))
      {
        return "chưa có thông tin"
      }
      else
        return moment(String(date)).format('DD/MM/YYYY');
    };
    const listLink = ref([] as string[]);
    let listFileName = ref([] as FileDetail[]);
    const loadingBar = ref(false);
    function base64ToBlob(base64: string, mime = 'image/jpeg'): Blob {
      const byteString = atob(base64.split(',')[1]);
      const byteArray = new Uint8Array(byteString.length);
      for (let i = 0; i < byteString.length; i++) {
        byteArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([byteArray], { type: mime });
    }
    const upload = () => {
      {
        // listCLS.value[0].sodienthoai = "0905333122"; // debug
        // listCLS.value[0].sodienthoai = "0905123456"; // debug
        listLink.value = [];
        var files = new FormData();
        listFileName.value.forEach(x =>
        {
          const blob = base64ToBlob(x.value); // convert từ string sang Blob
          files.append("formFiles", blob, x.nameFile);
        });
        loadingBar.value = true;
        axios.defaults.headers.common = {'Authorization': `Bearer ${store.state.token}`}
        axios.post(`../api/File/UploadFileCLS/${listCLS.value[0].sodienthoai}/${maYTe.value}`, files,
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data'
              }
            }).then(response => {

          loadingBar.value = false;
          listFileName.value = [];
          if(response.data.status) {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Tải kết quả thành công',
              life: 2000
            });
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          }
          else{
            toast.add({
              severity: 'warn',
              summary: 'Lỗi',
              detail:response.data.log,
              life: 2500
            });
          }
        })
            .catch(err => {
              toast.add({
                severity: 'error',
                summary: 'Lỗi',
                detail:err.response.data,
                life: 2500
              })});
      }
    };

    const fileChange = (fileList) => {
      var leng = fileList.length;
      for (var i = 0; i < leng; i++)
      {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    const sendFileResult = (id: number) => {
      console.log("#####$$$$$$$$$$ sendResult: " );
      zaloRepository.sendResult(id)
          .then((response) => {
            zaloRepository.getListCLS(maYTe.value)
                .then((response) => {
                  listFileCls.value = response.data;

                  listFileCls.value.forEach(x =>{
                    x.path =  x.path.split("/")[3];
                  })
                })
                .catch(err => {
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
          })
          .catch(err => {
            console.log("#####$$$$$$$$$$ sendFileResult 1111111: " );
            console.log("#####$$$$$$$$$$ sendFileResult 1111111aaa : " + JSON.stringify(err.response));
            console.log("#####$$$$$$$$$$ sendFileResult 1111111bbb : " + JSON.stringify(err.response.data));
            // console.log("#####$$$$$$$$$$ listCLS: " + JSON.stringify(err));
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải dữ liệu',
              life: 2000
            });
          });
    }



    const isLoading = ref<boolean>(false)
    function onLoading(loading: boolean) {
      isLoading.value = loading
    }

    const barcodeFormats = ref({
      aztec: false,
          code_128: true,
          code_39: true,
          code_93: true,
          codabar: false,
          databar: false,
          databar_expanded: false,
          data_matrix: false,
          dx_film_edge: false,
          ean_13: true,
          ean_8: true,
          itf: false,
          maxi_code: false,
          micro_qr_code: false,
          pdf417: false,
          qr_code: true,
          rm_qr_code: false,
          upc_a: true,
          upc_e: true,
          linear_codes: false,
          matrix_codes: false
    })
    const selectedBarcodeFormats = computed(() => {
          return Object.keys(barcodeFormats.value).filter((format) => barcodeFormats.value[format])
        })

    const decodedText = ref('')
    const openCamera = ref(false);

    const onDecode = (result) => {
      console.log('onDecode #############')
      console.log('onDecode ############# result: ' + result);
      openCamera.value = false;
      maYTe.value = result;
      loadListCls();
    }

    const onLoaded = () => {
      console.log('loaded')
    }
    const scanBarcode = () =>{
      openCamera.value = true;
      maYTe.value = "";
    }
    const deleteData = () => {
      listCLS.value = [];
      listCLSChuaThucHien.value = [];
      listCLSDaThucHien.value = [];
      maYTe.value="";
    }
    const result = ref('')
const onDetect = (detectedCodes) =>{
  console.log("#####$$$$$$$$$$ detectedCodes 1111111: ");
  console.log(detectedCodes)
  result.value = detectedCodes.map((code) => code.rawValue);
  console.log("#####$$$$$$$$$$ detectedCodes 1111111 result: " + result.value[0]);
  openCamera.value = false;
  maYTe.value = result.value;
  loadListCls();
}
    const selectedConstraints = ref({ facingMode: 'environment' });

    function paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

        ctx.strokeStyle = 'red'

        ctx.beginPath()
        ctx.moveTo(firstPoint.x, firstPoint.y)
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y)
        }
        ctx.lineTo(firstPoint.x, firstPoint.y)
        ctx.closePath()
        ctx.stroke()
      }
    }
    function paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: { x, y, width, height }
        } = detectedCode

        ctx.lineWidth = 2
        ctx.strokeStyle = '#007bff'
        ctx.strokeRect(x, y, width, height)
      }
    }
    function paintCenterText(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const { boundingBox, rawValue } = detectedCode

        const centerX = boundingBox.x + boundingBox.width / 2
        const centerY = boundingBox.y + boundingBox.height / 2

        const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width)

        ctx.font = `bold ${fontSize}px sans-serif`
        ctx.textAlign = 'center'

        ctx.lineWidth = 3
        ctx.strokeStyle = '#35495e'
        ctx.strokeText(detectedCode.rawValue, centerX, centerY)

        ctx.fillStyle = '#5cb984'
        ctx.fillText(rawValue, centerX, centerY)
      }
    }

    const trackFunctionOptions = [
      { text: 'nothing (default)', value: undefined },
      { text: 'outline', value: paintOutline },
      { text: 'centered text', value: paintCenterText },
      { text: 'bounding box', value: paintBoundingBox }
    ]
    const trackFunctionSelected = ref(trackFunctionOptions[1])

    const onDecodeLog = (text) => {
      console.log('Camera Error:' + text)
      result.value = text
    }

    const onErrorLog = (err) => {
      console.error('Camera Error:', err)
    }

    return {
      scanBarcode,
      openCamera,
      decodedText,
      onDecode,
      error,
      filters,
      clearFilter,
      initFilters,
      maYTe,
      formatDateTime,
      listCLS,
      loadListCls,
      ngaySinh,
      upload,
      listLink,
      listFileName,
      loadingBar,
      fileChange,
      listFileCls,
      sendFileResult,
      permissionCLS,
      //onDecode,
      onLoaded,
      isLoading,
      onLoading,
      onDetect,
      selectedBarcodeFormats,
      listCLSChuaThucHien,
      listCLSDaThucHien,
      deleteData,
      contentTrangThai,
      selectedConstraints,
      onDecodeLog,
      onErrorLog
    }
  }
}

</script>
<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.barcode-format-checkbox {
  margin-right: 10px;
  white-space: nowrap;
  display: inline-block;
}
</style>